import React from 'react';
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Chip,
} from '@mui/material';
import {
  People,
  TrendingUp,
  CheckCircle,
  Assessment,
  Schedule,
  School,
} from '@mui/icons-material';

interface AnalyticsOverviewProps {
  courseId: string;
}

const AnalyticsOverview: React.FC<AnalyticsOverviewProps> = ({ courseId }) => {
  // Mock data
  const summaryData = {
    totalRegistered: 245,
    activeStudents: 189,
    overallProgress: 68,
    passPercentage: 82,
    averageQuizScore: 76,
    averageCompletionTime: 42, // days
  };

  const cards = [
    {
      title: 'Total Registered',
      value: summaryData.totalRegistered,
      icon: <People sx={{ fontSize: 40, color: 'primary.main' }} />,
      color: 'primary',
      trend: '+12%',
      trendUp: true,
    },
    {
      title: 'Active Students',
      value: summaryData.activeStudents,
      icon: <TrendingUp sx={{ fontSize: 40, color: 'success.main' }} />,
      color: 'success',
      trend: '+5%',
      trendUp: true,
    },
    {
      title: 'Overall Progress',
      value: `${summaryData.overallProgress}%`,
      icon: <School sx={{ fontSize: 40, color: 'info.main' }} />,
      color: 'info',
      trend: '+3%',
      trendUp: true,
    },
    {
      title: 'Pass Percentage',
      value: `${summaryData.passPercentage}%`,
      icon: <CheckCircle sx={{ fontSize: 40, color: 'success.main' }} />,
      color: 'success',
      trend: '+2%',
      trendUp: true,
    },
    {
      title: 'Avg Quiz Score',
      value: `${summaryData.averageQuizScore}%`,
      icon: <Assessment sx={{ fontSize: 40, color: 'warning.main' }} />,
      color: 'warning',
      trend: '+1%',
      trendUp: true,
    },
    {
      title: 'Avg Completion Time',
      value: `${summaryData.averageCompletionTime} days`,
      icon: <Schedule sx={{ fontSize: 40, color: 'secondary.main' }} />,
      color: 'secondary',
      trend: '-3 days',
      trendUp: true,
    },
  ];

  return (
    <Grid container spacing={3}>
      {cards.map((card, index) => (
        <Grid item xs={12} sm={6} md={4} key={index}>
          <Card
            sx={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              transition: 'transform 0.2s, box-shadow 0.2s',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: 4,
              },
              cursor: 'pointer',
            }}
          >
            <CardContent>
              <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
                <Box>
                  <Typography color="text.secondary" variant="body2" gutterBottom>
                    {card.title}
                  </Typography>
                  <Typography variant="h4" component="div" fontWeight="bold">
                    {card.value}
                  </Typography>
                </Box>
                {card.icon}
              </Box>
              <Box display="flex" alignItems="center" gap={1}>
                <Chip
                  label={card.trend}
                  size="small"
                  color={card.trendUp ? 'success' : 'error'}
                  sx={{ fontWeight: 'bold' }}
                />
                <Typography variant="caption" color="text.secondary">
                  vs last period
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default AnalyticsOverview;

